import React, { useState } from 'react';
import Slider from 'react-slick';
import FsLightbox from 'fslightbox-react';

import King1 from '../../../assets/img/bg/K1.jpg';
import King2 from '../../../assets/img/bg/K2.jpg';
import King3 from '../../../assets/img/bg/K3.jpg';
import King4 from '../../../assets/img/bg/K4.jpg';
import King5 from '../../../assets/img/bg/K5.jpg';
import King6 from '../../../assets/img/bg/K6.jpg';
import King7 from '../../../assets/img/bg/K7.jpg';
import King8 from '../../../assets/img/bg/K8.jpg';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function First() {
  const [toggler, setToggler] = useState(false);
  const [slideIndex, setSlideIndex] = useState(1); // FsLightbox usa índices basados en 1

  const images = [King1, King2, King3, King4, King5, King6, King7, King8];

  const openLightbox = (index) => {
    setSlideIndex(index + 1);
    setToggler(!toggler);
  };

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 400,
    cssEase: "ease-in-out",
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <>
      <div className="about-area5 about-p p-relative">
        <div className="container pt-120 pb-40">
          <div className="row">
            <div className="col-lg-12">
              <div className="service-detail">

                <Slider {...settings} className="custom-slider">
                  {images.map((img, index) => (
                    <div key={index} className="slide-wrapper">
                      <figure className="image" onClick={() => openLightbox(index)}>
                        <img
                          src={img}
                          alt={`Habitación ${index + 1}`}
                          className="slider-image"
                        />
                      </figure>
                    </div>
                  ))}
                </Slider>

                <FsLightbox
                  toggler={toggler}
                  sources={images}
                  slide={slideIndex}
                />

                <div className="content-box mt-50">
                  <div className="row align-items-center mb-50">
                    <div className="col-lg-6 col-md-6">
                      <div className="price">
                        <h2>Habitación con Cama King</h2>
                      </div>
                    </div>
                  </div>

                  <p>
                    Déjate envolver por el lujo y la comodidad en nuestra amplia habitación con cama king size, diseñada especialmente para brindar una experiencia de descanso inigualable. Ideal para parejas que desean una escapada romántica o para viajeros individuales que valoran el confort y el estilo, esta habitación ofrece un ambiente elegante, cálido y perfectamente equipado para tu relajación total. Desde su diseño sofisticado hasta cada detalle cuidadosamente pensado, aquí encontrarás el equilibrio perfecto entre descanso y placer.
                  </p>

                  <h3>Características de la habitación</h3>
                  <ul className="room-features d-flex align-items-center flex-wrap">
                    <li><i className="fal fa-tv-retro"></i> TV</li>
                    <li><i className="fal fa-wifi"></i> Free Wifi</li>
                    <li><i className="fal fa-phone-rotary"></i> Teléfono</li>
                    <li><i className="fal fa-user"></i> Adultos: 2</li>
                    <li><i className="fal fa-bed"></i> Una cama King</li>
                    <li><i className="fal fa-car"></i> Estacionamiento</li>
                    <li><i className="fal fa-mug-hot"></i> Café</li>
                  </ul>

                  <div className="mb-50">
                    <a
                      href="https://us2.cloudbeds.com/en/reservation/2C4nnm?currency=mxn"
                      className="btn ss-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Reserva
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .custom-slider .slick-slide {
          padding: 0 10px;
        }

        .slide-wrapper {
          cursor: pointer;
        }

        .slider-image {
          width: 100%;
          height: 300px;
          object-fit: cover;
          border-radius: 4px;
          transition: transform 0.2s ease;
        }

        .slider-image:hover {
          transform: scale(1.01);
        }

        .slick-prev, .slick-next {
          z-index: 5;
        }

        .slick-prev { left: -13px; }
        .slick-next { right: -13px; }

        .slick-prev:before,
        .slick-next:before {
          font-size: 25px;
          color: #9e7b4f;
        }
      `}</style>
    </>
  );
}

export default First;
